import { render, staticRenderFns } from "./TlIntegration.vue?vue&type=template&id=ec0c7200&"
import script from "./TlIntegration.vue?vue&type=script&lang=js&"
export * from "./TlIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports